export type RichBlock =
  | { type: "paragraph"; text: string }
  | { type: "heading"; text: string }
  | { type: "quote"; text: string }
  | { type: "image"; src: string; caption: string };

export interface NewsItem {
  id: string;
  type: "news";
  title: string;
  summary: string;
  cover: string;
  author: string;
  source: string;
  publishedAt: string;
  timeRange: "week" | "month" | "older";
  newsType: "电影新闻" | "电视剧新闻" | "明星动态";
  categoryLabel: string;
  views: number;
  tags: string[];
  content: RichBlock[];
}

export interface MovieItem {
  id: string;
  type: "movie";
  media: "电影" | "电视剧";
  title: string;
  cover: string;
  director: string;
  cast: string[];
  year: number;
  genres: string[];
  region: string;
  rating: number;
  recommendIndex: number;
  synopsis: string;
  publishedAt: string;
  views: number;
  tags: string[];
}

export interface VarietyItem {
  id: string;
  type: "variety";
  title: string;
  cover: string;
  host: string;
  channel: string;
  platform: string;
  firstAirDate: string;
  airTime: string;
  genres: string[];
  description: string;
  publishedAt: string;
  timeRange: "week" | "month" | "older";
  views: number;
  tags: string[];
}

export interface PostItem {
  id: string;
  title: string;
  author: string;
  authorTag: string;
  createdAt: string;
  excerpt: string;
  content: string[];
  tags: string[];
  likes: number;
  replies: number;
}

export interface HeroSlide {
  id: string;
  kicker: string;
  title: string;
  summary: string;
  image: string;
  link: string;
  cta: string;
}

export const newsItems: NewsItem[] = [
  {
    id: "news-1",
    type: "news",
    title: "国庆档票房收官：总票房突破 42 亿，现实题材成最大赢家",
    summary:
      "为期八天的国庆档正式落下帷幕，多部现实题材影片表现亮眼，票房与口碑双线走高，观众对真诚叙事的热情远超预期。",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20lobby%20with%20warm%20amber%20lighting%20and%20red%20velvet%20seats%2C%20blurred%20movie%20posters%20on%20the%20wall%2C%20popcorn%20bucket%20on%20a%20wooden%20counter%2C%20editorial%20photography%2C%20shallow%20depth%20of%20field%2C%20cozy%20atmosphere&width=800&height=600&seq=ht-news-01&orientation=landscape",
    author: "陆青禾",
    source: "红桃网娱乐",
    publishedAt: "2026-10-17T09:20:00",
    timeRange: "week",
    newsType: "电影新闻",
    categoryLabel: "电影新闻",
    views: 38620,
    tags: ["国庆档", "票房", "现实题材"],
    content: [
      {
        type: "paragraph",
        text: "国庆档正式收官，据红桃网统计，八天假期累计产出票房 42.6 亿元，观影人次超过 9800 万。与往年不同的是，今年的票房曲线并没有依赖单一爆款，而是由三部体量相近的作品共同撑起了大盘。",
      },
      {
        type: "paragraph",
        text: "排在榜首的《长夜将尽》以 14.2 亿元收官，影片把镜头对准一座小城里的普通家庭，用克制的叙事讲完了一场漫长的告别。上映第五天，它的单日票房反超了首日，这种逆跌曲线在近年的档期中并不常见。",
      },
      {
        type: "image",
        src: "https://readdy.ai/api/search-image?query=warm%20cinematic%20still%20of%20a%20quiet%20small%20town%20street%20at%20dusk%2C%20golden%20sunlight%20falling%20on%20old%20brick%20walls%2C%20a%20lone%20bicycle%20leaning%20against%20a%20shop%20window%2C%20soft%20film%20grain%2C%20melancholic%20mood%2C%20editorial%20photography&width=1200&height=675&seq=ht-news-01-inline&orientation=landscape",
        caption: "《长夜将尽》取景于南方小城，导演坚持使用自然光拍摄。",
      },
      {
        type: "heading",
        text: "观众正在为“真实”买单",
      },
      {
        type: "paragraph",
        text: "从购票平台的用户评论看，今年档期的高分作品有一个共同点：它们都不约而同地放弃了强情节的堆叠，转而把力气放在人物身上。一位院线经理告诉我们，假期后半段出现了明显的“口碑驱动”现象，很多观众是看完评价才决定买票的。",
      },
      {
        type: "quote",
        text: "“观众不是不愿意进影院，而是不愿意为敷衍的故事进影院。”——某院线区域负责人",
      },
      {
        type: "paragraph",
        text: "值得关注的是，档期内中小成本影片的排片占比从去年的 18% 提升到了 27%。这意味着影院在排片上更加灵活，也给了新导演更多被看见的机会。接下来两周，《春风路上》《暗河》等影片仍有余量，最终大盘有望继续上探。",
      },
      {
        type: "paragraph",
        text: "红桃网将持续跟进后续的票房走势与影片口碑变化，并为读者整理值得走进影院的片单。",
      },
    ],
  },
  {
    id: "news-2",
    type: "news",
    title: "《长夜将尽》口碑逆袭：一部小成本电影如何撬动档期亚军",
    summary:
      "没有大场面，也没有流量阵容，这部讲述普通家庭告别的作品凭口碑一路逆跌，成为今年最具讨论度的黑马。",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20vintage%20cinema%20screen%20with%20soft%20projector%20beam%2C%20empty%20red%20seats%20in%20warm%20dim%20light%2C%20dust%20particles%20floating%20in%20the%20air%2C%20nostalgic%20film%20atmosphere%2C%20artsy%20editorial%20photography&width=800&height=600&seq=ht-news-02&orientation=landscape",
    author: "沈亦然",
    source: "红桃网影视观察",
    publishedAt: "2026-10-16T18:05:00",
    timeRange: "week",
    newsType: "电影新闻",
    categoryLabel: "电影新闻",
    views: 29410,
    tags: ["长夜将尽", "口碑", "黑马"],
    content: [
      {
        type: "paragraph",
        text: "上映首日排片只有 11.4%，第七天已经涨到 24.8%。《长夜将尽》的逆袭路径，被不少从业者称为“今年最舒服的一次市场反馈”。",
      },
      {
        type: "paragraph",
        text: "影片的成本并不高，全片 90% 的场景集中在老宅与医院走廊。导演在采访中坦言，剧组最贵的开销是“等一场真的雨”。这种近乎固执的耐心，最终换来了观众的口口相传。",
      },
      {
        type: "quote",
        text: "“我们没有想过要赢，只是想把一个家庭最后的样子拍清楚。”——影片导演",
      },
      {
        type: "heading",
        text: "小成本影片的窗口正在打开",
      },
      {
        type: "paragraph",
        text: "多位发行人士认为，今年的市场环境对中小成本影片更友好：档期不再被头部项目完全挤占，观众对同质化大片的耐受度也在下降。只要口碑能立住，影院愿意给出黄金场次。",
      },
      {
        type: "paragraph",
        text: "截至发稿，《长夜将尽》的评分稳定在 8.6 分，预测总票房上调至 17 亿元。",
      },
    ],
  },
  {
    id: "news-3",
    type: "news",
    title: "年度剧集片单公布：12 部新剧定档，都市与悬疑各占一半",
    summary:
      "平台公布第四季度片单，都市情感与悬疑推理成为两大主力赛道，多部积压已久的作品终于确定播出时间。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20streaming%20platform%20interface%20glow%20reflected%20on%20a%20dark%20wooden%20table%2C%20television%20screen%20showing%20blurred%20drama%20scenes%2C%20warm%20lamp%20in%20the%20corner%2C%20cozy%20living%20room%2C%20cinematic%20editorial%20photography&width=800&height=600&seq=ht-news-03&orientation=landscape",
    author: "周映",
    source: "红桃网剧集",
    publishedAt: "2026-10-15T11:30:00",
    timeRange: "week",
    newsType: "电视剧新闻",
    categoryLabel: "电视剧新闻",
    views: 21840,
    tags: ["定档", "剧集片单", "悬疑"],
    content: [
      {
        type: "paragraph",
        text: "平台在昨日的发布会上公布了第四季度的 12 部新剧片单，其中都市情感 5 部、悬疑推理 5 部、古装与年代剧各 1 部。从题材分布看，平台明显在收缩古装投入，把资源集中在更易形成话题的现代题材上。",
      },
      {
        type: "paragraph",
        text: "片单中最受关注的是悬疑剧《雾港》，该剧由电影团队操刀，全剧 12 集，采用一集一个视角的叙事结构。预告片放出 24 小时播放量破千万。",
      },
      {
        type: "heading",
        text: "短剧集成为新的竞争点",
      },
      {
        type: "paragraph",
        text: "值得注意的是，本次片单中有 7 部作品集数在 16 集以内。平台内容负责人表示，观众对注水的容忍度已经很低，短剧集能让单集投入更集中，也更容易在国际市场发行。",
      },
      {
        type: "paragraph",
        text: "具体播出时间将在下周陆续公布，红桃网会第一时间更新每部剧的定档信息与主创阵容。",
      },
    ],
  },
  {
    id: "news-4",
    type: "news",
    title: "从配角到主角：演员林澈的十年，终于被看见了",
    summary:
      "出道十年、演过 27 个配角，林澈凭《暗河》中的一场独白戏被观众记住。我们和他聊了聊那些没被剪进正片的夜晚。",
    cover:
      "https://readdy.ai/api/search-image?query=backstage%20dressing%20room%20mirror%20with%20warm%20bulb%20lights%2C%20script%20pages%20scattered%20on%20a%20makeup%20table%2C%20single%20chair%20under%20soft%20spotlight%2C%20moody%20theatrical%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=ht-news-04&orientation=landscape",
    author: "许之南",
    source: "红桃网人物",
    publishedAt: "2026-10-14T20:10:00",
    timeRange: "week",
    newsType: "明星动态",
    categoryLabel: "明星动态",
    views: 45210,
    tags: ["林澈", "人物", "暗河"],
    content: [
      {
        type: "paragraph",
        text: "采访约在剧组附近的一家旧咖啡馆。林澈来得比约定时间早二十分钟，坐在靠窗的位置，把剧本摊在桌上，用铅笔在页边写着什么。",
      },
      {
        type: "paragraph",
        text: "过去十年，他演过警察、司机、便利店店员、叛徒，大多数角色只有几场戏。真正让观众记住他的，是《暗河》第七集里那段长达四分钟的无台词独白——他只是坐在审讯室里，把一只纸杯捏扁，再慢慢展开。",
      },
      {
        type: "quote",
        text: "“那场戏我们拍了 11 条。导演最后用的是第一条，因为我还没有想好该怎么演。”",
      },
      {
        type: "heading",
        text: "等待也是一种准备",
      },
      {
        type: "paragraph",
        text: "他不太愿意把这段经历讲成励志故事，反复强调“运气占很大一部分”。但工作人员说，他会为一场两页纸的戏准备三套人物小传，这个习惯保持了十年。",
      },
      {
        type: "paragraph",
        text: "新片约已经排到了明年夏天，他依然习惯提前一个月进组。问他现在最想演什么，他想了想说：“想演一个特别普通、但活得很有劲的人。”",
      },
    ],
  },
  {
    id: "news-5",
    type: "news",
    title: "秋季电影市场观察：影院开始重新思考“排片逻辑”",
    summary:
      "当观众的选择越来越依赖口碑，传统按预售定排片的方式正在失效。多家院线尝试动态调整场次，效果初显。",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20projection%20room%20with%20vintage%20film%20projector%20casting%20warm%20light%20beams%2C%20reels%20stacked%20on%20metal%20shelves%2C%20dust%20in%20the%20projector%20light%2C%20cinematic%20moody%20photography&width=800&height=600&seq=ht-news-05&orientation=landscape",
    author: "程野",
    source: "红桃网产业",
    publishedAt: "2026-10-12T09:00:00",
    timeRange: "week",
    newsType: "电影新闻",
    categoryLabel: "电影新闻",
    views: 15230,
    tags: ["院线", "产业观察", "排片"],
    content: [
      {
        type: "paragraph",
        text: "过去，影院的排片表往往在影片上映前一周就基本确定，预售成绩是最重要的参考。但在今年秋季，越来越多的院线开始把“上座率”和“次日口碑”纳入动态调整。",
      },
      {
        type: "paragraph",
        text: "一家拥有 60 家影院的院线负责人透露，他们从 9 月起试行“每日两次调场”机制，允许门店经理根据实时上座率增减场次。试行一个月后，整体上座率提升了 6.8%。",
      },
      {
        type: "heading",
        text: "从卖座位到经营时间",
      },
      {
        type: "paragraph",
        text: "更灵活的做法也带来了新的问题：临时撤场会影响已购票观众的体验。因此多数院线采取的做法是“只增不减”，把空置的小厅让给口碑片。",
      },
      {
        type: "paragraph",
        text: "业内人士认为，排片逻辑的变化本质上是影院从“卖座位”转向“经营时间”。当银幕数不再是稀缺资源，如何把每一个时段填满，才是真正的功课。",
      },
    ],
  },
  {
    id: "news-6",
    type: "news",
    title: "《雾港》杀青特辑曝光，全片海上实景拍摄历时 78 天",
    summary:
      "悬疑剧《雾港》公布杀青特辑，剧组在海上连续拍摄 78 天，大量夜戏与风暴戏份全部实拍完成。",
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20harbor%20at%20dawn%20with%20old%20fishing%20boats%20and%20wooden%20pier%2C%20thick%20mist%20over%20dark%20water%2C%20single%20warm%20lantern%20glowing%20on%20the%20dock%2C%20melancholic%20cinematic%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=ht-news-06&orientation=landscape",
    author: "苏晓",
    source: "红桃网剧集",
    publishedAt: "2026-10-10T16:40:00",
    timeRange: "week",
    newsType: "电视剧新闻",
    categoryLabel: "电视剧新闻",
    views: 18920,
    tags: ["雾港", "杀青", "实景拍摄"],
    content: [
      {
        type: "paragraph",
        text: "《雾港》剧组昨日发布杀青特辑，三分钟的视频里几乎全是摇晃的甲板和扑面而来的海水。制片人介绍，全片 90% 的镜头在海上完成，最长的一次连续拍摄达到 19 个小时。",
      },
      {
        type: "paragraph",
        text: "为了保证真实感，剧组没有使用大型造浪设备，而是等真实的天气。78 天里有 21 天因为风浪过大被迫停工，成本压力可想而知。",
      },
      {
        type: "quote",
        text: "“我们不是在拍海上，我们是在海上生活了一段时间。”——摄影指导",
      },
      {
        type: "paragraph",
        text: "该剧预计于明年第一季度上线，共 12 集，将在平台上以周更方式播出。",
      },
    ],
  },
  {
    id: "news-7",
    type: "news",
    title: "第四届城市电影节开幕，37 部青年导演作品集中展映",
    summary:
      "本届电影节以“看见新人”为主题，设置主竞赛、短片实验与城市影像三个单元，展映将持续十天。",
    cover:
      "https://readdy.ai/api/search-image?query=outdoor%20film%20festival%20venue%20at%20night%20with%20warm%20string%20lights%2C%20red%20carpet%20entrance%20and%20blurred%20crowd%20silhouettes%2C%20art%20deco%20building%20facade%2C%20festive%20cinematic%20editorial%20photography&width=800&height=600&seq=ht-news-07&orientation=landscape",
    author: "何雨",
    source: "红桃网现场",
    publishedAt: "2026-10-07T21:15:00",
    timeRange: "month",
    newsType: "电影新闻",
    categoryLabel: "电影新闻",
    views: 12760,
    tags: ["电影节", "青年导演", "展映"],
    content: [
      {
        type: "paragraph",
        text: "第四届城市电影节在城市影像中心开幕，本届共收到 612 部报名作品，最终 37 部进入展映单元，其中 21 部为导演长片处女作。",
      },
      {
        type: "paragraph",
        text: "开幕片《春风路上》讲述三位年轻人在城市边缘合租的故事，全片使用 16 毫米胶片拍摄，画面颗粒感明显。导演说，这是为了保留“租来的房子里那种旧旧的味道”。",
      },
      {
        type: "heading",
        text: "让新人有第一块银幕",
      },
      {
        type: "paragraph",
        text: "组委会表示，本届特别增设了“首作扶持计划”，为 5 部青年导演作品提供后续发行支持。展映将持续十天，部分场次安排主创映后交流。",
      },
    ],
  },
  {
    id: "news-8",
    type: "news",
    title: "音乐盛典官宣阵容：三代歌手同台，经典改编成看点",
    summary:
      "年度音乐盛典公布首批阵容，涵盖摇滚、民谣与流行多个方向，多组跨世代合作舞台提前曝光。",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20amber%20spotlights%20and%20deep%20red%20backdrop%2C%20microphone%20stand%20alone%20in%20the%20center%2C%20light%20haze%20and%20silhouettes%20of%20instruments%2C%20moody%20live%20music%20photography&width=800&height=600&seq=ht-news-08&orientation=landscape",
    author: "林一鸣",
    source: "红桃网音乐",
    publishedAt: "2026-10-03T14:20:00",
    timeRange: "month",
    newsType: "明星动态",
    categoryLabel: "明星动态",
    views: 20450,
    tags: ["音乐盛典", "阵容", "现场"],
    content: [
      {
        type: "paragraph",
        text: "年度音乐盛典公布首批 18 组嘉宾阵容，涵盖出道三十年的摇滚乐队与近两年崭露头角的新声音。主办方透露，本次将设置三个跨世代合作舞台。",
      },
      {
        type: "paragraph",
        text: "最受关注的是一场“老歌新编”环节：六首华语经典将被重新编曲，由原唱与年轻音乐人共同完成。彩排片段显示，其中一首被改编成了慢速的电子民谣。",
      },
      {
        type: "paragraph",
        text: "盛典将于下月中旬举行，红桃网将带来现场报道与后台专访。",
      },
    ],
  },
  {
    id: "news-9",
    type: "news",
    title: "影视基地迎来拍摄旺季，超 40 个剧组同时进驻",
    summary:
      "进入秋季拍摄黄金期，多个影视基地迎来今年最忙碌的时段，年代场景与海上场景成为最抢手的资源。",
    cover:
      "https://readdy.ai/api/search-image?query=film%20studio%20backlot%20with%20vintage%20chinese%20street%20facade%20and%20warm%20afternoon%20sunlight%2C%20wooden%20scaffolding%20and%20film%20lights%2C%20quiet%20production%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=ht-news-09&orientation=landscape",
    author: "程野",
    source: "红桃网产业",
    publishedAt: "2026-09-28T10:30:00",
    timeRange: "month",
    newsType: "电视剧新闻",
    categoryLabel: "电视剧新闻",
    views: 9860,
    tags: ["影视基地", "剧组", "拍摄"],
    content: [
      {
        type: "paragraph",
        text: "多家影视基地反馈，今年秋季的剧组进驻数量创下近三年新高，部分热门年代街景的档期已经排到年底。",
      },
      {
        type: "paragraph",
        text: "基地负责人表示，为了提升周转效率，他们对场景进行了模块化改造，同一条街可以在两天内完成从民国到九十年代的切换。",
      },
      {
        type: "paragraph",
        text: "忙碌的背后是内容供给的恢复，但也带来了新的挑战——灯光、群演等基础工种出现明显缺口。",
      },
    ],
  },
  {
    id: "news-10",
    type: "news",
    title: "经典剧集修复版上线，4K 版本还原三十年前的画面质感",
    summary:
      "一批经典剧集完成 4K 修复并上线，修复团队用十个月时间逐帧处理胶片划痕，保留了原有的色彩风格。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20archival%20canisters%20on%20a%20warm%20wooden%20shelf%2C%20soft%20window%20light%20and%20dust%20in%20the%20air%2C%20nostalgic%20archival%20atmosphere%2C%20editorial%20still%20life%20photography&width=800&height=600&seq=ht-news-10&orientation=landscape",
    author: "周映",
    source: "红桃网剧集",
    publishedAt: "2026-09-20T15:00:00",
    timeRange: "older",
    newsType: "电视剧新闻",
    categoryLabel: "电视剧新闻",
    views: 11340,
    tags: ["修复", "经典剧集", "4K"],
    content: [
      {
        type: "paragraph",
        text: "一批陪伴观众成长的经典剧集以 4K 修复版重新上线。修复团队介绍，最难的不是提高清晰度，而是保留画面里原本的味道。",
      },
      {
        type: "paragraph",
        text: "为此，团队放弃了自动降噪，改用人工逐帧处理。十个月里，六位修复师处理了超过 12 万帧画面。",
      },
      {
        type: "paragraph",
        text: "修复版上线首周，播放量超出平台预期两倍。弹幕里出现最多的一句话是：“原来那时候的灯光这么好看。”",
      },
    ],
  },
];

export const movieItems: MovieItem[] = [
  {
    id: "m-1",
    type: "movie",
    media: "电影",
    title: "长夜将尽",
    cover:
      "https://readdy.ai/api/search-image?query=minimalist%20movie%20poster%20of%20a%20lone%20figure%20standing%20at%20the%20end%20of%20a%20dim%20corridor%2C%20warm%20amber%20doorway%20light%20spilling%20across%20the%20floor%2C%20deep%20crimson%20shadow%2C%20cinematic%20dramatic%20lighting%2C%20elegant%20negative%20space&width=600&height=800&seq=ht-movie-01&orientation=portrait",
    director: "陈牧之",
    cast: ["林澈", "宋知微", "王砚"],
    year: 2026,
    genres: ["剧情", "家庭"],
    region: "中国",
    rating: 8.6,
    recommendIndex: 96,
    synopsis:
      "一座南方小城，一个即将拆迁的老宅，一位决定停下治疗的母亲。离散多年的三个孩子被迫回到同一张餐桌前，在七天里重新学习如何告别。影片以克制的镜头语言，记录一个普通家庭最后的相处时光。",
    publishedAt: "2026-10-01",
    views: 186200,
    tags: ["剧情", "家庭", "口碑"],
  },
  {
    id: "m-2",
    type: "movie",
    media: "电影",
    title: "暗河",
    cover:
      "https://readdy.ai/api/search-image?query=noir%20movie%20poster%20with%20a%20silhouette%20walking%20through%20a%20rain%20soaked%20alley%2C%20reflections%20of%20warm%20orange%20streetlights%20on%20wet%20pavement%2C%20dense%20fog%2C%20high%20contrast%20cinematic%20lighting%2C%20minimalist%20composition&width=600&height=800&seq=ht-movie-02&orientation=portrait",
    director: "许汉川",
    cast: ["周慎", "林澈", "阿依"],
    year: 2026,
    genres: ["悬疑", "犯罪"],
    region: "中国",
    rating: 8.2,
    recommendIndex: 94,
    synopsis:
      "一起看似普通的失踪案，牵出十年前被掩埋的旧账。刑警队长在调查中逐渐发现，所有线索都指向自己的过去。一部关于记忆与选择的黑色电影。",
    publishedAt: "2026-09-12",
    views: 152400,
    tags: ["悬疑", "犯罪", "黑色电影"],
  },
  {
    id: "m-3",
    type: "movie",
    media: "电影",
    title: "春风路上",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20movie%20poster%20of%20three%20young%20people%20sitting%20on%20a%20rooftop%20at%20golden%20hour%2C%20city%20skyline%20in%20soft%20orange%20haze%2C%20film%20grain%20texture%2C%20bittersweet%20youth%20atmosphere%2C%20minimalist%20cinematic%20composition&width=600&height=800&seq=ht-movie-03&orientation=portrait",
    director: "李文竹",
    cast: ["赵青", "陈屿", "何小满"],
    year: 2026,
    genres: ["剧情", "青春"],
    region: "中国",
    rating: 8.0,
    recommendIndex: 90,
    synopsis:
      "三位在城市边缘合租的年轻人，各自揣着一个不敢说出口的梦想。房租涨价的通知贴在门上，他们决定用一个夏天，把想做的事都做一遍。",
    publishedAt: "2026-10-08",
    views: 98700,
    tags: ["青春", "合租", "城市"],
  },
  {
    id: "m-4",
    type: "movie",
    media: "电影",
    title: "星际回声",
    cover:
      "https://readdy.ai/api/search-image?query=sci%20fi%20movie%20poster%20with%20a%20solitary%20astronaut%20silhouette%20facing%20a%20giant%20amber%20planet%2C%20deep%20red%20nebula%20clouds%2C%20soft%20glowing%20spacecraft%20window%2C%20epic%20minimalist%20cinematic%20composition%2C%20warm%20dark%20tones&width=600&height=800&seq=ht-movie-04&orientation=portrait",
    director: "顾南舟",
    cast: ["沈燃", "苏黎", "程墨"],
    year: 2025,
    genres: ["科幻", "冒险"],
    region: "中国",
    rating: 8.4,
    recommendIndex: 92,
    synopsis:
      "在距离地球 4.2 光年的空间站里，一名工程师收到了一段来自故乡的旧广播。为了确认那段声音的真实性，她决定独自驾驶补给舱返航。",
    publishedAt: "2026-08-20",
    views: 211800,
    tags: ["科幻", "太空", "视觉"],
  },
  {
    id: "m-5",
    type: "movie",
    media: "电影",
    title: "海上列车",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20movie%20poster%20of%20vintage%20train%20windows%20reflecting%20a%20sunset%20over%20the%20sea%2C%20warm%20peach%20and%20crimson%20tones%2C%20empty%20seats%20and%20curtains%20swaying%2C%20nostalgic%20cinematic%20atmosphere%2C%20minimal%20elegant%20composition&width=600&height=800&seq=ht-movie-05&orientation=portrait",
    director: "高见",
    cast: ["叶知秋", "梁川"],
    year: 2025,
    genres: ["爱情", "剧情"],
    region: "日本",
    rating: 8.1,
    recommendIndex: 88,
    synopsis:
      "一列沿着海岸线行驶的慢车，两位陌生人共享同一个包厢。列车会在每个小站停留七分钟，他们约定，每站都下去看一眼海。",
    publishedAt: "2026-07-15",
    views: 132600,
    tags: ["爱情", "旅行", "治愈"],
  },
  {
    id: "m-6",
    type: "movie",
    media: "电影",
    title: "山城旧事",
    cover:
      "https://readdy.ai/api/search-image?query=period%20drama%20movie%20poster%20of%20steep%20stone%20stairs%20in%20a%20mountain%20town%2C%20warm%20lantern%20glow%20and%20misty%20evening%20air%2C%20old%20wooden%20houses%20layered%20up%20the%20hill%2C%20muted%20crimson%20and%20sepia%20palette%2C%20cinematic%20composition&width=600&height=800&seq=ht-movie-06&orientation=portrait",
    director: "冉平",
    cast: ["胡安", "齐夏", "罗小满"],
    year: 2026,
    genres: ["剧情", "历史"],
    region: "中国",
    rating: 8.3,
    recommendIndex: 91,
    synopsis:
      "上世纪四十年代，山城里的一间照相馆记录了整条街的悲欢。老板用一台老相机，替所有人保存了他们最想留住的样子。",
    publishedAt: "2026-06-28",
    views: 87600,
    tags: ["年代", "山城", "摄影"],
  },
  {
    id: "m-7",
    type: "movie",
    media: "电影",
    title: "逆光而行",
    cover:
      "https://readdy.ai/api/search-image?query=inspiring%20sports%20movie%20poster%20of%20a%20runner%20silhouette%20against%20a%20huge%20warm%20sunrise%2C%20long%20shadows%20on%20a%20red%20running%20track%2C%20lens%20flare%20and%20film%20grain%2C%20energetic%20minimalist%20cinematic%20composition&width=600&height=800&seq=ht-movie-07&orientation=portrait",
    director: "王策",
    cast: ["陈默", "许安", "白露"],
    year: 2026,
    genres: ["运动", "励志"],
    region: "中国",
    rating: 7.8,
    recommendIndex: 84,
    synopsis:
      "因伤退役的长跑运动员回到县城，成了中学田径队的教练。他要带的五个孩子，没有一个人相信自己能跑完一千五百米。",
    publishedAt: "2026-09-30",
    views: 76500,
    tags: ["运动", "励志", "热血"],
  },
  {
    id: "m-8",
    type: "movie",
    media: "电视剧",
    title: "雾港",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20series%20poster%20of%20a%20foggy%20harbor%20with%20a%20single%20lighthouse%20beam%20cutting%20through%20dense%20mist%2C%20dark%20teal%20water%20and%20warm%20amber%20lamp%2C%20silhouette%20of%20a%20boat%2C%20cinematic%20suspense%20atmosphere&width=600&height=800&seq=ht-movie-08&orientation=portrait",
    director: "许汉川",
    cast: ["周慎", "阿依", "苏黎"],
    year: 2026,
    genres: ["悬疑", "剧情"],
    region: "中国",
    rating: 8.7,
    recommendIndex: 97,
    synopsis:
      "一座以渔业为生的小岛，每年雾季都会有船失踪。新来的港务员发现，所有的失踪记录上，都出现了同一个签名。12 集短剧，一集一个视角。",
    publishedAt: "2026-10-12",
    views: 243900,
    tags: ["悬疑", "短剧集", "海岛"],
  },
  {
    id: "m-9",
    type: "movie",
    media: "电视剧",
    title: "日常之上",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20urban%20drama%20poster%20of%20a%20cozy%20apartment%20window%20at%20night%2C%20warm%20lamp%20light%20and%20plants%20on%20the%20sill%2C%20rain%20streaks%20on%20the%20glass%2C%20blurred%20city%20lights%20outside%2C%20intimate%20cinematic%20mood&width=600&height=800&seq=ht-movie-09&orientation=portrait",
    director: "张一苇",
    cast: ["宋知微", "梁川", "何小满"],
    year: 2026,
    genres: ["都市", "情感"],
    region: "中国",
    rating: 7.9,
    recommendIndex: 86,
    synopsis:
      "四个住在同一栋老楼里的家庭，因为一部坏掉的电梯开始互相认识。生活没有大事发生，但每一天都在悄悄改变。",
    publishedAt: "2026-09-05",
    views: 118200,
    tags: ["都市", "群像", "生活流"],
  },
  {
    id: "m-10",
    type: "movie",
    media: "电视剧",
    title: "沉默的证词",
    cover:
      "https://readdy.ai/api/search-image?query=crime%20thriller%20poster%20of%20an%20empty%20interrogation%20room%20with%20a%20single%20hanging%20lamp%2C%20metal%20table%20and%20two%20chairs%2C%20long%20shadows%20on%20grey%20walls%2C%20cold%20yet%20warm%20amber%20accent%2C%20cinematic%20minimalism&width=600&height=800&seq=ht-movie-10&orientation=portrait",
    director: "李昂",
    cast: ["王砚", "齐夏", "白露"],
    year: 2025,
    genres: ["悬疑", "律政"],
    region: "中国",
    rating: 8.2,
    recommendIndex: 89,
    synopsis:
      "一位习惯替人辩护的律师，接下了自己职业生涯中最沉默的当事人。全剧 16 集，围绕一份没有签名的证词展开。",
    publishedAt: "2026-05-18",
    views: 143700,
    tags: ["悬疑", "律政", "推理"],
  },
  {
    id: "m-11",
    type: "movie",
    media: "电影",
    title: "最后的放映员",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20movie%20poster%20of%20an%20old%20projectionist%20in%20a%20small%20theater%2C%20warm%20projector%20beam%20cutting%20through%20dusty%20darkness%2C%20red%20velvet%20seats%20in%20soft%20focus%2C%20melancholic%20cinematic%20portrait%2C%20film%20grain&width=600&height=800&seq=ht-movie-11&orientation=portrait",
    director: "陈牧之",
    cast: ["胡安", "叶知秋"],
    year: 2025,
    genres: ["剧情", "文艺"],
    region: "法国",
    rating: 8.5,
    recommendIndex: 93,
    synopsis:
      "小镇最后一家影院即将关门，年迈的放映员决定在最后一天，放一部没有观众看过的电影。关于电影与告别的一封情书。",
    publishedAt: "2026-04-20",
    views: 68100,
    tags: ["文艺", "影院", "告别"],
  },
  {
    id: "m-12",
    type: "movie",
    media: "电影",
    title: "六月的海",
    cover:
      "https://readdy.ai/api/search-image?query=sunny%20seaside%20coming%20of%20age%20movie%20poster%20with%20two%20teenagers%20walking%20along%20the%20shore%2C%20warm%20coral%20sunset%20and%20gentle%20waves%2C%20soft%20film%20grain%2C%20hopeful%20nostalgic%20summer%20atmosphere%2C%20minimal%20cinematic%20composition&width=600&height=800&seq=ht-movie-12&orientation=portrait",
    director: "高见",
    cast: ["赵青", "程墨"],
    year: 2024,
    genres: ["青春", "家庭"],
    region: "韩国",
    rating: 7.9,
    recommendIndex: 82,
    synopsis:
      "高考结束的那个六月，两个少年骑着自行车去看海。他们约定，无论以后去哪里，都要在同一个夏天回来一次。",
    publishedAt: "2026-03-10",
    views: 59300,
    tags: ["青春", "海边", "夏天"],
  },
];

export const varietyItems: VarietyItem[] = [
  {
    id: "v-1",
    type: "variety",
    title: "星光夜话",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20late%20night%20talk%20show%20studio%20set%20with%20amber%20lamps%20and%20deep%20red%20curtain%2C%20two%20vintage%20armchairs%20facing%20each%20other%2C%20soft%20haze%20and%20bokeh%20lights%2C%20intimate%20cinematic%20atmosphere&width=800&height=600&seq=ht-variety-01&orientation=landscape",
    host: "苏念",
    channel: "城市卫视",
    platform: "城市卫视",
    firstAirDate: "2026-09-04",
    airTime: "每周五 22:00",
    genres: ["脱口秀", "访谈"],
    description:
      "一档把演播厅变成客厅的深夜访谈节目。每期邀请两位来自不同领域的嘉宾，关掉提词器，聊那些没被写进通稿的故事。",
    publishedAt: "2026-10-13",
    timeRange: "week",
    views: 86200,
    tags: ["访谈", "深夜", "真实"],
  },
  {
    id: "v-2",
    type: "variety",
    title: "一起出发吧",
    cover:
      "https://readdy.ai/api/search-image?query=travel%20reality%20show%20scene%20of%20a%20small%20van%20on%20a%20winding%20mountain%20road%20at%20sunrise%2C%20warm%20golden%20light%20over%20layered%20hills%2C%20friends%20silhouettes%20by%20the%20roadside%2C%20documentary%20cinematic%20style&width=800&height=600&seq=ht-variety-02&orientation=landscape",
    host: "何炅宁",
    channel: "海岸卫视",
    platform: "海岸卫视",
    firstAirDate: "2026-08-16",
    airTime: "每周日 20:30",
    genres: ["真人秀", "旅行"],
    description:
      "六位嘉宾、一辆旧面包车、一条没有地图的路线。节目组只提供油费和一句提示：往有风的地方开。",
    publishedAt: "2026-10-11",
    timeRange: "week",
    views: 134500,
    tags: ["旅行", "真人秀", "公路"],
  },
  {
    id: "v-3",
    type: "variety",
    title: "唱响舞台",
    cover:
      "https://readdy.ai/api/search-image?query=live%20music%20competition%20stage%20with%20a%20single%20singer%20silhouette%20under%20warm%20amber%20spotlight%2C%20deep%20red%20background%20panels%2C%20floating%20light%20haze%2C%20dramatic%20concert%20photography&width=800&height=600&seq=ht-variety-03&orientation=landscape",
    host: "林一鸣",
    channel: "星海视频",
    platform: "星海视频",
    firstAirDate: "2026-07-05",
    airTime: "每周六 21:00",
    genres: ["音乐", "竞演"],
    description:
      "不设导师席、不设淘汰赛，每期八组音乐人用一首原创作品争夺下一期的开场位置。舞台只留给声音。",
    publishedAt: "2026-10-09",
    timeRange: "week",
    views: 176800,
    tags: ["音乐", "原创", "舞台"],
  },
  {
    id: "v-4",
    type: "variety",
    title: "笑场",
    cover:
      "https://readdy.ai/api/search-image?query=comedy%20club%20stage%20with%20a%20vintage%20microphone%20and%20warm%20brick%20wall%2C%20small%20round%20tables%20and%20amber%20lamps%2C%20soft%20smoke%20and%20spotlight%2C%20cozy%20intimate%20atmosphere%20cinematic&width=800&height=600&seq=ht-variety-04&orientation=landscape",
    host: "大鹏子",
    channel: "欢乐频道",
    platform: "欢乐频道",
    firstAirDate: "2026-06-12",
    airTime: "每周四 20:00",
    genres: ["脱口秀", "喜剧"],
    description:
      "十二位喜剧新人，每期围绕一个生活议题写五分钟段子。没有评委打分，只有现场观众的笑声计分器。",
    publishedAt: "2026-10-06",
    timeRange: "month",
    views: 98700,
    tags: ["喜剧", "新人", "脱口秀"],
  },
  {
    id: "v-5",
    type: "variety",
    title: "厨房奇遇",
    cover:
      "https://readdy.ai/api/search-image?query=rustic%20kitchen%20with%20warm%20morning%20sunlight%20through%20window%2C%20fresh%20vegetables%20and%20wooden%20cutting%20board%20on%20a%20farm%20table%2C%20steam%20rising%20from%20a%20pot%2C%20cozy%20food%20editorial%20photography&width=800&height=600&seq=ht-variety-05&orientation=landscape",
    host: "陈有味",
    channel: "生活卫视",
    platform: "生活卫视",
    firstAirDate: "2026-05-20",
    airTime: "每周三 19:30",
    genres: ["真人秀", "美食"],
    description:
      "每期去一个普通人的厨房，用冰箱里现有的食材做一桌饭。节目的规则只有一条：不许买菜。",
    publishedAt: "2026-09-29",
    timeRange: "month",
    views: 76500,
    tags: ["美食", "生活", "治愈"],
  },
  {
    id: "v-6",
    type: "variety",
    title: "城市玩家",
    cover:
      "https://readdy.ai/api/search-image?query=night%20city%20rooftop%20with%20warm%20string%20lights%20and%20young%20people%20playing%20a%20game%2C%20glowing%20city%20skyline%20in%20the%20background%2C%20energetic%20warm%20amber%20tones%2C%20cinematic%20lifestyle%20photography&width=800&height=600&seq=ht-variety-06&orientation=landscape",
    host: "阿凯",
    channel: "星海视频",
    platform: "星海视频",
    firstAirDate: "2026-08-02",
    airTime: "每周五 20:00",
    genres: ["真人秀", "游戏"],
    description:
      "把整座城市当作棋盘，嘉宾需要在 12 小时内完成一系列和陌生人有关的任务。输赢不重要，遇见谁才重要。",
    publishedAt: "2026-09-22",
    timeRange: "month",
    views: 112300,
    tags: ["城市", "游戏", "素人"],
  },
  {
    id: "v-7",
    type: "variety",
    title: "声音的旅行",
    cover:
      "https://readdy.ai/api/search-image?query=field%20recording%20scene%20with%20a%20vintage%20microphone%20and%20headphones%20on%20a%20wooden%20table%20by%20a%20window%2C%20warm%20autumn%20light%2C%20forest%20blurred%20outside%2C%20quiet%20contemplative%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=ht-variety-07&orientation=landscape",
    host: "顾声",
    channel: "城市卫视",
    platform: "城市卫视",
    firstAirDate: "2026-04-11",
    airTime: "每周日 21:30",
    genres: ["音乐", "纪实"],
    description:
      "声音采集者带着一支麦克风走遍小城，记录清晨的菜市场、深夜的修车铺，再把这些声音编成一首歌。",
    publishedAt: "2026-09-15",
    timeRange: "month",
    views: 54300,
    tags: ["声音", "纪实", "音乐"],
  },
  {
    id: "v-8",
    type: "variety",
    title: "周末喜剧社",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20weekend%20comedy%20show%20set%20with%20colorful%20vintage%20sofas%20and%20amber%20spotlights%2C%20small%20audience%20silhouettes%2C%20playful%20theatrical%20atmosphere%2C%20cinematic%20editorial%20photography&width=800&height=600&seq=ht-variety-08&orientation=landscape",
    host: "小满",
    channel: "欢乐频道",
    platform: "欢乐频道",
    firstAirDate: "2026-03-08",
    airTime: "每周六 19:00",
    genres: ["喜剧", "脱口秀"],
    description:
      "一档把周末夜晚交给笑声的节目。固定班底加上每期一位跨界嘉宾，聊工作、聊房租、聊那些让人又气又笑的小事。",
    publishedAt: "2026-09-08",
    timeRange: "month",
    views: 63100,
    tags: ["喜剧", "周末", "生活"],
  },
];

export const postItems: PostItem[] = [
  {
    id: "p-1",
    title: "《长夜将尽》里那场餐桌戏，你们怎么看？",
    author: "橘子汽水",
    authorTag: "资深影迷",
    createdAt: "2026-10-16T21:40:00",
    excerpt:
      "母亲把菜第三次端回厨房热的时候，我一直没忍住。导演没有给任何特写，但那个背影比任何台词都重。",
    content: [
      "昨晚二刷《长夜将尽》，注意到一个第一次没看清的细节：母亲每次起身去热菜，都会顺手把桌上歪掉的筷子摆正。这个动作重复了三次，最后一次她已经没有力气把筷子摆平了。",
      "导演全程没有给脸部特写，镜头一直停在中景，让我们像坐在桌子另一头一样看着。这种克制反而让人难受。",
      "另外想聊聊结尾那个空镜，老宅拆到只剩一堵墙，墙上还有孩子小时候画的身高线。你们觉得这是希望还是彻底的告别？",
    ],
    tags: ["长夜将尽", "影片解读", "剧情讨论"],
    likes: 342,
    replies: 57,
  },
  {
    id: "p-2",
    title: "整理了一份国庆档观影顺序，避雷向",
    author: "放映员老周",
    authorTag: "影院从业者",
    createdAt: "2026-10-15T14:20:00",
    excerpt:
      "按“情绪浓度”从低到高排的，建议不要一天连看两部现实题材，真的会缓不过来。",
    content: [
      "第一优先：《长夜将尽》，建议留出散场后独自走一段路的时间。",
      "第二优先：《春风路上》，适合和朋友一起看，散场还能聊很久。",
      "第三优先：《暗河》，悬疑线扎实，但夜戏偏多，别看太晚的场次。",
      "最后提醒一句：节假日影院人多，尽量提前二十分钟到，取票机真的会排队。",
    ],
    tags: ["国庆档", "观影指南", "片单"],
    likes: 268,
    replies: 41,
  },
  {
    id: "p-3",
    title: "综艺里那些“真实反应”，到底有几分是真的？",
    author: "夜航船",
    authorTag: "综艺观察",
    createdAt: "2026-10-14T10:05:00",
    excerpt:
      "在录制现场做过几次观众，说点能说的。很多时候我们看到的“意外”，其实是第三次录制。",
    content: [
      "先声明，我很喜欢现在的旅行类综艺，也不是要唱衰。只是想分享一下现场看到的东西。",
      "一场四十分钟的录制，实际拍摄接近三小时。嘉宾会累，累了反应就会变淡，导演组会要求“再来一次”。这不算造假，但确实和成片给人的感觉不一样。",
      "所以我现在看综艺，更愿意看那些有点笨拙、有点接不上话的瞬间，那通常是真的。",
    ],
    tags: ["综艺", "幕后", "行业观察"],
    likes: 196,
    replies: 88,
  },
  {
    id: "p-4",
    title: "求推荐：像《雾港》一样节奏慢但后劲大的悬疑剧",
    author: "不睡星人",
    authorTag: "新注册用户",
    createdAt: "2026-10-13T23:10:00",
    excerpt:
      "不要那种每集都反转的，想要氛围感强一点、看完会想很久的类型，先谢谢各位。",
    content: [
      "最近把《雾港》追完了，特别喜欢它不急着给答案的处理方式。",
      "之前看过《沉默的证词》，也很喜欢，但那个更偏律政推理。想找氛围更重一点的。",
      "如果有海上、雨夜、小镇这类场景的就更好了，感谢推荐。",
    ],
    tags: ["悬疑剧", "求推荐", "雾港"],
    likes: 121,
    replies: 63,
  },
  {
    id: "p-5",
    title: "分享一个在家看片的布置，成本不到三百",
    author: "半盏灯",
    authorTag: "生活玩家",
    createdAt: "2026-10-11T19:35:00",
    excerpt:
      "一盏暖光落地灯、一块深色布、一个蓝牙音箱，客厅立刻有了点小影院的意思。",
    content: [
      "不用投影仪也能提升观影氛围，关键是把顶灯关掉，只留一盏低色温的灯放在屏幕侧后方。",
      "深色布挂在身后可以减少反光，音箱比电视自带喇叭重要得多。",
      "最后一个小建议：看电影前把手机放到另一个房间。这是我今年做过最有效的改变。",
    ],
    tags: ["生活方式", "家庭影院", "好物"],
    likes: 387,
    replies: 32,
  },
];

export const heroSlides: HeroSlide[] = [
  {
    id: "hero-1",
    kicker: "头条 · 电影",
    title: "国庆档收官，现实题材赢下这一局",
    summary:
      "总票房 42.6 亿元，三部作品共同撑起大盘。观众用脚投票，为真诚的叙事买单。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20red%20carpet%20premiere%20scene%20with%20deep%20crimson%20curtains%20and%20warm%20golden%20spotlights%2C%20elegant%20silhouettes%20of%20a%20crowd%2C%20dark%20moody%20atmosphere%20with%20rich%20shadows%20for%20text%20overlay%2C%20editorial%20photography&width=1600&height=900&seq=ht-hero-01&orientation=landscape",
    link: "/news/news-1",
    cta: "阅读全文",
  },
  {
    id: "hero-2",
    kicker: "编辑推荐 · 电影",
    title: "《星际回声》：一封寄往 4.2 光年外的信",
    summary:
      "今年最安静的科幻片，没有拯救世界，只有一个工程师想确认一段广播是不是真的。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20space%20scene%20of%20a%20lone%20astronaut%20facing%20a%20giant%20amber%20planet%2C%20deep%20crimson%20nebula%20clouds%20and%20soft%20glowing%20spacecraft%20window%2C%20epic%20dark%20minimalist%20composition%2C%20film%20grain%2C%20editorial%20sci%20fi%20photography&width=1600&height=900&seq=ht-hero-02&orientation=landscape",
    link: "/movies/m-4",
    cta: "查看详情",
  },
  {
    id: "hero-3",
    kicker: "热播 · 剧集",
    title: "《雾港》开播：一集一个视角，雾散之前没人无辜",
    summary:
      "12 集短剧集，海上实景拍摄 78 天。今年最值得关灯观看的悬疑作品之一。",
    image:
      "https://readdy.ai/api/search-image?query=moody%20foggy%20harbor%20at%20night%20with%20a%20single%20warm%20lighthouse%20beam%20cutting%20through%20dense%20mist%2C%20dark%20water%20reflections%20and%20silhouette%20of%20an%20old%20boat%2C%20cinematic%20suspense%20atmosphere%2C%20rich%20red%20and%20amber%20tones&width=1600&height=900&seq=ht-hero-03&orientation=landscape",
    link: "/movies/m-8",
    cta: "查看详情",
  },
  {
    id: "hero-4",
    kicker: "今晚必看 · 综艺",
    title: "《一起出发吧》：没有地图的公路，才叫旅行",
    summary:
      "六个人、一辆旧面包车、一句“往有风的地方开”。这档节目把综艺拍成了公路电影。",
    image:
      "https://readdy.ai/api/search-image?query=travel%20documentary%20scene%20of%20a%20vintage%20van%20on%20a%20winding%20mountain%20road%20at%20golden%20sunrise%2C%20warm%20amber%20light%20over%20layered%20hills%2C%20friends%20silhouettes%20by%20the%20roadside%2C%20cinematic%20wide%20composition&width=1600&height=900&seq=ht-hero-04&orientation=landscape",
    link: "/variety/v-2",
    cta: "查看详情",
  },
  {
    id: "hero-5",
    kicker: "人物 · 专访",
    title: "林澈：等了十年，他终于等到一场四分钟的无台词戏",
    summary:
      "演过 27 个配角，保持一个习惯十年。这一次，观众记住了他的名字。",
    image:
      "https://readdy.ai/api/search-image?query=backstage%20dressing%20room%20with%20warm%20bulb%20mirror%20lights%20and%20a%20single%20chair%20under%20soft%20spotlight%2C%20script%20pages%20on%20a%20wooden%20makeup%20table%2C%20deep%20crimson%20curtain%2C%20moody%20theatrical%20cinematic%20photography&width=1600&height=900&seq=ht-hero-05&orientation=landscape",
    link: "/news/news-4",
    cta: "阅读全文",
  },
];

export const movieStills: string[] = [
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20quiet%20rainy%20street%20at%20night%2C%20warm%20shop%20window%20glow%20reflected%20on%20wet%20pavement%2C%20a%20single%20figure%20with%20an%20umbrella%2C%20muted%20red%20and%20amber%20tones%2C%20film%20grain%2C%20editorial%20photography&width=900&height=600&seq=ht-still-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20warm%20family%20dinner%20table%20lit%20by%20a%20single%20pendant%20lamp%2C%20steam%20rising%20from%20bowls%2C%20empty%20chairs%20and%20quiet%20shadows%2C%20intimate%20melancholic%20mood%2C%20soft%20film%20grain&width=900&height=600&seq=ht-still-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20narrow%20corridor%20with%20afternoon%20sunlight%20cutting%20through%20dusty%20air%2C%20old%20wooden%20doors%20and%20faded%20posters%2C%20warm%20sepia%20palette%2C%20nostalgic%20quiet%20atmosphere&width=900&height=600&seq=ht-still-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20rooftop%20at%20dusk%20overlooking%20a%20city%2C%20warm%20orange%20sky%20and%20soft%20haze%2C%20two%20young%20people%20sitting%20apart%20in%20silence%2C%20bittersweet%20cinematic%20mood%2C%20film%20grain&width=900&height=600&seq=ht-still-04&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20a%20foggy%20pier%20at%20dawn%20with%20wooden%20posts%20and%20an%20old%20lantern%2C%20thick%20mist%20over%20dark%20water%2C%20lone%20boat%20silhouette%2C%20moody%20suspense%20atmosphere%2C%20muted%20crimson%20accents&width=900&height=600&seq=ht-still-05&orientation=landscape",
  "https://readdy.ai/api/search-image?query=cinematic%20film%20still%20of%20an%20old%20cinema%20projection%20beam%20through%20dusty%20darkness%2C%20empty%20red%20velvet%20seats%20in%20soft%20focus%2C%20warm%20amber%20light%2C%20nostalgic%20film%20atmosphere%2C%20editorial%20photography&width=900&height=600&seq=ht-still-06&orientation=landscape",
];